import { platform } from '~/lib/params'
import { cn } from '~/lib/utils'

const SPINNER_BARS = 12

type Variant = 'platform' | 'circle'

export function Spinner(props: { class?: string; variant?: Variant }) {
  if (props.variant === 'circle') return <CircleSpinner class={props.class} />
  return (
    <>
      {platform === 'ios' ? (
        <IosSpinner class={props.class} />
      ) : (
        <CircleSpinner class={props.class} />
      )}
    </>
  )
}

function IosSpinner(props: { class?: string }) {
  return (
    <div class={cn('relative size-10 text-[#5DCAA5]', props.class)}>
      {Array.from({ length: SPINNER_BARS }, (_, i) => (
        <span
          class="absolute left-1/2 top-1/2 animate-spin-fade rounded-full"
          style={{
            width: '11%',
            height: '26%',
            'margin-left': '-5.5%',
            'margin-top': '-13%',
            background: 'currentColor',
            'transform-origin': 'center bottom',
            transform: `rotate(${i * 30}deg) translateY(-80%)`,
            'animation-delay': `${-(1 - i / SPINNER_BARS)}s`,
          }}
        />
      ))}
    </div>
  )
}

function CircleSpinner(props: { class?: string }) {
  return (
    <svg
      class={cn('size-10 animate-spinner-rotate text-[#5DCAA5]', props.class)}
      viewBox="0 0 50 50"
    >
      <circle
        class="animate-spinner-dash"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-dasharray="1,150"
        stroke-dashoffset="0"
      />
    </svg>
  )
}
